module.exports = __webpack_public_path__ + "img/1.b8654ebc.jpg";